<template>
    <div class="grid grid-rows-[min-content_1fr] gap-8">
        <ClosinglockHeader portal="employee">
            <template #navigation>
                <EmployeeNavigation />
            </template>
        </ClosinglockHeader>

        <RouterView />
    </div>
</template>

<script setup lang="ts">
import { useCurrentUserService } from '@/services/current-user.service';
import { onMounted } from 'vue';

import ClosinglockHeader from '@/components/Navigation/ClosinglockHeader.vue';
import EmployeeNavigation from '@/components/Navigation/top-nav/EmployeeNavigation.vue';

defineProps<{
    currentUser: unknown;
    userAccountId: number;
    supportAccountId: string;
    userHasEmployeeRole: boolean;
    csrf_token: string;
}>();

const currentUserService = useCurrentUserService();

onMounted(() => {
    currentUserService.loadGlobalUserOrLogout();
});
</script>
